import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import previousRouteSelector from 'root/src/client/logic/project/selectors/previousRouteSelector'
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel'
import encodedQuerySelector from 'root/src/client/logic/route/selectors/encodedQuerySelector'
import { HOMEPAGE_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import { SIGN_UP_TOKEN } from 'root/src/shared/descriptions/endpoints/endpointIds'
import setSession from 'root/src/client/logic/auth/util/setSession'
import authSelector from 'root/src/client/logic/auth/util/authSelector'

export default ({ password }) => async (dispatch, getState) => {
	const state = getState()
	const { email, userGroup, token } = encodedQuerySelector(state)
	try {
		const { body, error } = await invokeApiRequest(SIGN_UP_TOKEN, { token, password }, state)

		if (error) {
			throw error
		}

		const {
			accessToken,
			refreshToken,
		} = body

		setSession(authSelector({ accessToken, refreshToken }))
		mixpanel.alias(email)
		mixpanel.track(mixpanelEvents.signUp,
			{ userGroup, previousRoute: previousRouteSelector(state) })
		mixpanel.people.set({ email, userGroup })
		mixpanel.identify(email)
		return pushRouteClient({ routeId: HOMEPAGE_ROUTE_ID })
	} catch ({ code, message }) {
		let fieldError = { message }
		if (code === 'InvalidPasswordException') {
			fieldError = {
				password: 'Password (Must have a lower & uppercase letter, number and symbol)',
			}
		}
		throw fieldError
	}
}
